// extracted by mini-css-extract-plugin
export default {"module":"thanksBody_module__wPISO","close":"thanksBody_close__1sW5J","icon":"thanksBody_icon__jfa2s","title":"thanksBody_title__j+iEk","subtitle":"thanksBody_subtitle__6mtiM"};